var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreadcrumbsBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 3,
    viewBox: "0 0 12 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 2.3C9.96487 2.3 9.45 1.78513 9.45 1.15C9.45 0.514873 9.96487 3.74383e-07 10.6 4.02145e-07C11.2351 4.29907e-07 11.75 0.514873 11.75 1.15C11.75 1.78513 11.2351 2.3 10.6 2.3Z",
    fill: "#071F3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.3C5.36487 2.3 4.85 1.78513 4.85 1.15C4.85 0.514873 5.36487 1.7331e-07 6 2.01072e-07C6.63513 2.28835e-07 7.15 0.514873 7.15 1.15C7.15 1.78513 6.63513 2.3 6 2.3Z",
    fill: "#071F3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 1.15C0.25 1.78513 0.764872 2.3 1.4 2.3C2.03513 2.3 2.55 1.78513 2.55 1.15C2.55 0.514873 2.03513 2.77623e-08 1.4 0C0.764872 -2.77623e-08 0.25 0.514873 0.25 1.15Z",
    fill: "#071F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbsBlack);
export default __webpack_public_path__ + "static/media/breadcrumbs_black.395754248c1cee566e4e50177a25ef45.svg";
export { ForwardRef as ReactComponent };